import React from 'react'
import { getDateFormat } from '../../Config/functions'
export const PaymentLinkHistory = ({data}:any) => {
  return (
    <div className="col-sm-12 card py-5 mt-5">
    <div className="row">
        <div className="col-sm-12 px-4">
            <h4>Payment Link History</h4>
        
            {data!=null && data.length >0 ?
           
           data.map((el:any) =>
             (
            <table className="table table-striped border-0 mt-4">
                <tbody>
                    <tr>
                        <th scope="row">Date & Time:</th>
                        <td>{el.date ? `${getDateFormat(el.date.split("/")[0])}-${el.date.split("/")[1]}` : ""}</td>
                        <th scope="row">Expert : </th>
                        <td>{el.expert}</td>
                        <th scope="row">Amount:</th>
                        <td>{el.amount}</td>
                        <th scope="row">Link:</th>
                        <td>{el.link}</td>
                        
                    </tr>
                </tbody>
            </table>)) : "No Payment Link History Available "}
            
        </div>
    </div>

</div>
  )
}
